<template>
  <div
    class="navbar-government flex items-stretch text-chplus-regular text-nav-light"
  >
    <div class="flex-1 text-left border-b-2 lg:border-b-2px border-nav-light">
      <router-link
        :to="peopleRoute"
        class="text-chplus-regular"
        replace
        :class="{ 'font-bold': isPeoplePage }"
        >{{ $t("components.nav.navbar_government.tab_people") }}</router-link
      >
    </div>
    <div
      class="flex-1 border-b-2 lg:border-b-2px border-nav-light  text-center"
      v-if="isLegislativeRoute || isVotePage"
    >
      <router-link
        :to="{ name: 'vote' }"
        class="text-chplus-regular "
        replace
        :class="{ 'font-bold': isVotePage }"
        >{{ $t("components.nav.navbar_government.tab_vote") }}</router-link
      >
    </div>
    <div class="flex-1 text-right border-b-2 lg:border-b-2px border-nav-light">
      <router-link
        :to="responsibilitiesRoute"
        replace
        class="text-chplus-regular"
        :class="{ 'font-bold': isResponsibilitiesPage }"
        >{{
          $t("components.nav.navbar_government.tab_responsibilities")
        }}</router-link
      >
    </div>
  </div>
</template>

<script>
import constants from "../../constants";
import { mapGetters } from "vuex";

export default {
  name: "NavbarGovernment",
  methods: {
    getPeopleRoute(key) {
      switch (key) {
        case constants.ROUTE_GROUP_LEGISLATIVE:
          return {
            name: "legislative",
            params: {
              councilId: this.currentCouncil
                ? this.currentCouncil.id
                : this.defaultCouncilId
            }
          };
        case constants.ROUTE_GROUP_JUDICIARY:
          return { name: "judiciary" };
        case constants.ROUTE_GROUP_EXECUTIVE:
          return { name: "executive" };
        default:
          return { name: "" };
      }
    },
    getResponsibilitiesRoute(key) {
      switch (key) {
        case constants.ROUTE_GROUP_LEGISLATIVE:
          return { name: "legislative-responsibilities" };
        case constants.ROUTE_GROUP_JUDICIARY:
          return { name: "judiciary-responsibilities" };
        case constants.ROUTE_GROUP_EXECUTIVE:
          return { name: "executive-responsibilities" };
        default:
          return { name: "" };
      }
    }
  },
  computed: {
    ...mapGetters("council", ["currentCouncil", "defaultCouncilId"]),
    isLegislativeRoute() {
      return this.$route.meta.page_for === constants.ROUTE_GROUP_LEGISLATIVE;
    },
    peopleRoute() {
      if (this.$route.meta.page_for != undefined) {
        return this.getPeopleRoute(this.$route.meta.page_for);
      } else {
        return "/legislative/1";
      }
    },
    voteRoute() {
      return "vote";
    },
    responsibilitiesRoute() {
      if (this.$route.meta.page_for != undefined) {
        return this.getResponsibilitiesRoute(this.$route.meta.page_for);
      } else {
        return "/legislative/responsibilities";
      }
    },
    isResponsibilitiesPage() {
      return this.$router.currentRoute.name == this.responsibilitiesRoute?.name;
    },
    isPeoplePage() {
      return this.$route.name == this.peopleRoute?.name;
    },
    isVotePage() {
      return this.$route.name == "vote";
    }
  }
};
</script>

<style scoped>
.navbar-government {
  box-sizing: border-box;
  padding: 0 2.25rem;
  height: 100%;
  line-height: 1.25em;
}
.navbar-government a,
.navbar-government button {
  line-height: 1em;
  vertical-align: baseline;
}
@media screen and (min-width: 768px) {
  .navbar-government {
    padding: 0 3.7rem;
  }
}

@media (min-width: 1024px) {
  .navbar-government {
    height: fit-content;
  }
}
</style>
